var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.478a1.826 1.826 0 001.826 1.827h17.348A1.826 1.826 0 0021 13.478v-7.76a.228.228 0 00-.067-.162.228.228 0 00-.161-.067H.228a.228.228 0 00-.161.067.228.228 0 00-.067.162v7.76zm15.065-2.054h2.74a.685.685 0 01.484 1.169.685.685 0 01-.485.2h-2.739a.684.684 0 110-1.369zM3.652 7.772h7.304a.685.685 0 110 1.37H3.652a.685.685 0 010-1.37zm0 3.652h2.74a.685.685 0 010 1.37h-2.74a.684.684 0 110-1.37z",
    fill: "#00BBA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.521A1.826 1.826 0 0019.174.695H1.826A1.826 1.826 0 000 2.521v1.37c0 .06.024.119.067.161a.228.228 0 00.161.067h20.544A.228.228 0 0021 3.891v-1.37z",
    fill: "#10F0D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsActive);
export default __webpack_public_path__ + "static/media/payments-active.ff8411c7aaf86a5ba1bacea533cc541a.svg";
export { ForwardRef as ReactComponent };